<template>
  <div :class="wrapperClass" :style="`padding-inline: ${togglePadding};`">
    <!--<div class="toggle__label toggle__label--start" @click="modelValue = false">{{translate(offLabel)}}</div>-->
    <div :class="controlsClass">
      <div
        v-if="labelPosition === 'start'"
        class="toggle__label toggle__label--start"
        @click="modelValue = !modelValue">
        {{ modelValue ? translate(onLabel) : translate(offLabel) }}
      </div>
      <div
        v-if="labelPosition === 'both'"
        class="toggle__label toggle__label--start"
        @click="modelValue = false">
        {{ translate(offLabel) }}
      </div>
      <div class="toggle__controls-line" @click="toggleValue">
        <div class="toggle__controls-knob flex-middle flex-center bg-inverse"></div>
      </div>
      <div
        v-if="labelPosition === 'end'"
        class="toggle__label toggle__label--end"
        @click="modelValue = !modelValue">
        {{ modelValue ? translate(onLabel) : translate(offLabel) }}
      </div>
      <div
        v-if="labelPosition === 'both'"
        class="toggle__label toggle__label--end"
        @click="modelValue = true">
        {{ translate(onLabel) }}
      </div>
    </div>
    <input v-model="value" type="hidden" v-bind="inputAttrs" />
  </div>
</template>

<script>
import ToggleInputMixin from "@/client/extensions/mixins/baseComponents/form/controls/input/toggleInput.js";

export default {
  mixins: [ToggleInputMixin],
  props: {
    // component doesnt display this. this is for padding calculation
    icon: {
      type: [String,Boolean],
      default: false,
    },
    // component doesnt display this. this is for padding calculation
    iconEnd: {
      type: [String,Boolean],
      default: false,
    },

    values: {
      type: Array,
      default: [true, false],
    },
    modelValue: {}, // this doesn't work from mixin. reason - unknown
  },
  data: function () {
    return {};
  },
  computed: {
    value1() {
      return this.values[0];
    },
    value2() {
      return this.values[1];
    },
    controlsClass() {
      let classArray = ["toggle__controls"];

      if (this.value === this.value2) {
        classArray.push("active");
      }

      return classArray;
    },
    togglePadding() {
      let result = 0;
      if (this.icon) {
        result = result + 1.0;
      }

      if (this.iconEnd) {
        result = result + 1.0;
      }

      return result + "em";
    },
  },
  watch: {},
  methods: {
    toggleValue(newValue) {
      if (this.value === this.value1) {
        this.value = this.value2;
        return;
      }

      if (this.value === this.value2) {
        this.value = this.value1;
        return;
      }

      this.value = this.value1;
    },
  },
};
</script>

<style scoped lang="scss"></style>
